import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const enableScreenShareForNonModerator = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/enable-screen-share`,
  );
  return response.data;
};

function useEnableScreenShareForNonModerator(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) =>
      enableScreenShareForNonModerator({ sessionId }),
    ...mutationOptions,
  });
}

const disableScreenShareForNonModerator = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/disable-screen-share`,
  );
  return response.data;
};

function useDisableScreenShareForNonModerator(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) =>
      disableScreenShareForNonModerator({ sessionId }),
    ...mutationOptions,
  });
}

export {
  useDisableScreenShareForNonModerator,
  useEnableScreenShareForNonModerator,
};
